// @grozd/icons — Lucide React wrapper
// Dodajemo ovde samo ikone koje se zaista koriste, ne cijelu biblioteku

export {
  // Layout
  LayoutGrid,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ArrowLeft,
  ArrowRight,
  // User
  User,
  Users,
  UserPlus,
  UserX,
  Lock,
  LogIn,
  LogOut,
  Eye,
  EyeOff,
  Phone,
  Building2,
  Landmark,
  // Email
  Mail,
  MailCheck,
  MailOpen,
  Inbox,
  Send,
  // Settings
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Key,
  Server,
  // Actions
  Plus,
  Edit,
  Trash2,
  Search,
  Bell,
  Save,
  Copy,
  Filter,
  RefreshCw,
  MoreVertical,
  MoreHorizontal,
  Calendar,
  Clock,
  Database,
  ExternalLink,
  RotateCcw,
  Ban,
  History,
  Pause,
  Play,
  Power,
  Activity,
  Gauge,
  // Status
  Check,
  CheckCircle,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Info,
  Loader2,
  // Files
  FileText,
  Download,
  Upload,
  Archive,
  HardDrive,
  PackageOpen,
  // Money
  Receipt,
  CreditCard,
  Wallet,
  // Time / locations
  Hourglass,
  KeyRound,
  Globe,
  MapPin,
  // Commerce & inventory (ERP shell)
  Package,
  Box,
  Layers,
  Truck,
  Tag,
  Coins,
  ClipboardCheck,
  Calculator,
  TrendingUp,
  TrendingDown,
  // Theme
  Sun,
  Moon,
} from "lucide-react";

// LucideIcon type re-export — koristi se u shell komponentama
// (ErpSidebar, ErpMegaMenu, ErpUserMenu) gdje se ikona prima kao prop.
export type { LucideIcon } from "lucide-react";
